const C = {
  name: "Location",
  dimensions: { width: 44, height: 42 },
  content: `
    <g fill="currentColor" stroke="none">
        <path d="M20.0043 38C8.35427 38 2.00427 35.36 2.00427 34C2.00427 32.68 8.00427 30.16 19.0043 30.01V33C19.0043 33.55 19.4543 34 20.0043 34C20.5543 34 21.0043 33.55 21.0043 33V30.01C32.0043 30.16 38.0043 32.68 38.0043 34C38.0043 35.36 31.6543 38 20.0043 38ZM12.0043 10C12.0043 5.59 15.5943 2 20.0043 2C24.4143 2 28.0043 5.59 28.0043 10C28.0043 14.41 24.4143 18 20.0043 18C15.5943 18 12.0043 14.41 12.0043 10ZM21.0043 28.01V19.95C26.0543 19.45 30.0043 15.18 30.0043 10C30.0043 4.49 25.5143 0 20.0043 0C14.4943 0 10.0043 4.49 10.0043 10C10.0043 15.18 13.9543 19.45 19.0043 19.95V28.01C9.40427 28.14 0.00427246 30.19 0.00427246 34C0.00427246 37.94 10.0643 40 20.0043 40C29.9443 40 40.0043 37.94 40.0043 34C40.0043 30.19 30.6043 28.14 21.0043 28.01Z"/>
    </g>
  `
};
export {
  C as Location
};
